import React, { useMemo, useState } from 'react';

// Spot the odd piece out: a grid of the same chess glyph with exactly one different one — tap it.
// Every correct tap grows the grid by one row/col, so it gets harder as you go. Pure state, instant
// rounds — no timers, so it never fights the ~10s wait.
const PIECES = ['♟', '♞', '♝', '♜', '♛', '♚', '♙', '♘', '♗', '♖', '♕', '♔'];

interface Round {
  size: number; // grid is size×size
  odd: number; // index of the odd cell
  base: string;
  oddPiece: string;
}

function makeRound(size: number): Round {
  const base = PIECES[Math.floor(Math.random() * PIECES.length)];
  let oddPiece = base;
  while (oddPiece === base) {
    oddPiece = PIECES[Math.floor(Math.random() * PIECES.length)];
  }
  return {
    size,
    base,
    oddPiece,
    odd: Math.floor(Math.random() * size * size),
  };
}

export default function SpotTheOddOne(): React.ReactNode {
  const [round, setRound] = useState<Round>(() => makeRound(2));
  const [score, setScore] = useState(0);
  const [miss, setMiss] = useState<number>();

  const cells = useMemo(
    () => Array.from({ length: round.size * round.size }),
    [round.size, round.odd],
  );

  const pick = (cell: number) => {
    if (cell === round.odd) {
      setScore((s) => s + 1);
      setMiss(undefined);
      setRound(makeRound(Math.min(6, round.size + 1)));
    } else {
      setMiss(cell);
      window.setTimeout(() => setMiss(undefined), 220);
    }
  };

  return (
    <div className="cm-minigame">
      <div className="cm-minigame-score">
        Found <strong>{score}</strong>
      </div>
      <div
        className="cm-spot-grid"
        style={{ gridTemplateColumns: `repeat(${round.size}, minmax(0, 1fr))` }}
      >
        {cells.map((_, cell) => (
          <button
            key={cell}
            type="button"
            className={`cm-spot-cell${cell === miss ? ' is-miss' : ''}`}
            onClick={() => pick(cell)}
          >
            {cell === round.odd ? round.oddPiece : round.base}
          </button>
        ))}
      </div>
    </div>
  );
}
